const odinFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}
const pushFirebaseConfig = {
  apiKey: process.env.REACT_APP_PUSH_API_KEY,
  authDomain: process.env.REACT_APP_PUSH_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_PUSH_DATABASE_URL,
  projectId: process.env.REACT_APP_PUSH_PROJECT_ID,
  storageBucket: process.env.REACT_APP_PUSH_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_PUSH_SENDER_ID,
  appId: process.env.REACT_APP_PUSH_APP_ID
}

export { pushFirebaseConfig, odinFirebaseConfig }
